import React from 'react';
import PropTypes from 'prop-types';

const DividerWithMessage = ({ message }) => {
  return (
    <div className="tw-mb-6 tw-flex tw-items-center">
      <hr className="tw-border-gray-300" />
      <span className="tw-body-xs-bold tw-relative tw-mx-2 tw-break-keep tw-text-gray-700">
        {message}
      </span>
      <hr className="tw-border-gray-300" />
    </div>
  );
};

DividerWithMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default DividerWithMessage;
